export { default } from './BigSlider';
